<template>
    <div class="cdc-details-team">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'trialsDetails' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Trials Details
                        </div>
                    </div>    

                    <div class="col-md-4">
                        <div class="top-navbar-right">
                            <!-- <button class="btn btn-ecdc btn-shadow ml-3">Export Report</button> -->
                        </div>
                    </div>                       
                </div>
            </div>

            <hr />

            <div class="reference-card">

                <h2 class="section-title">Showing Results For:</h2>
              
                <div class="table-responsive">
                    <table class="table table-striped result-table reference-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Team Name</th>
                                <th>TL Name</th>
                                <th>Division</th>
                                <th>Region</th>
                                <th>Area</th>
                                <th class="text-right">Number of Cdc</th>
                                <th class="text-right">Trial</th>
                                <th class="text-right">Non trial</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>{{topResult.start_date}}</td>
                                <td>{{topResult.team_name}}</td>
                                <td>{{topResult.tl_name}}</td>
                                <td>{{topResult.division}}</td>
                                <td>{{topResult.region_name}}</td>
                                <td>{{topResult.area_name}}</td>
                                <td class="text-right">{{topResult.number_of_cdc}}</td>
                                <td class="text-right">{{topResult.trial}}</td>
                                <td class="text-right">{{topResult.non_trial}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row">
                <div id="table-content-col" class="col-xl col-lg" v-bind:class="{ 'col-lg-9' : toggleFilter }">

                    <div class="table-options row justify-content-between align-items-center">
                        <div class="col-lg">
                            <!-- <div class="table-search form-inline d-inline-block ml-4">
                                <input type="text" class="form-control" placeholder="Search by keyword">                         <button type="button" class="btn btn-ecdc btn-circle">
                                    <app-icon-search></app-icon-search>
                                </button>       
                            </div> -->
                        </div>
                        <div class="col-lg">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateTop"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>
                        </div>
                    </div>

                    

                    <div class="table-responsive">
                        <table class="table table-hover table-striped result-table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>USER/BA</th>
                                    <th>Venue</th>
                                    <th>Category</th>
                                    <th>Customer name</th>
                                    <th>Products</th>
                                </tr>
                            </thead>

                            <tbody v-if="!isLoading">
                                <tr v-for="cdc in cdcTeamData.result" v-bind:key="cdc.tid">
                                    <td>{{cdc.date}}</td>
                                    <td>{{cdc.ba_name}}</td>
                                    <td>{{cdc.venue_name}}</td>
                                    <td>{{cdc.venue_category}}</td>
                                    <td>{{cdc.customer_name}}</td>
                                    <td>
                                        <span v-for="product in cdc.product" v-bind:key="product.id">{{product.name}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="row justify-content-between table-options">
                        <div class="col-lg">
                            <select class="form-control custom-select" v-model="pageLimit" @change="pagination(1)">
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            per page
                        </div>
                        <div class="col-lg text-center">
                            {{ showingResults }}
                        </div>
                        <div class="col-lg">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateBottom"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>

                        </div>
                    </div>

                </div>
            </div>
        </div>

        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getTrialDetailByTeam } from '../api'
import Loader from './Loader.vue'
import Paginate from 'vuejs-paginate'
// import IconSearch from '../svg/Search.vue'
import moment from 'moment'

export default {
    components: {
        appLoader: Loader,
        appPaginate: Paginate,
        // appIconSearch: IconSearch
    },
    data() {
        return {
            data: {
                work_progress_tl_id: this.$route.params.wptlid,
            },
            catOptions: [
                { name: 'Public Place', id: 1 },
                { name: 'Horeca', id: 2 },
                { name: 'Traditional Market', id: 3 },
                { name: 'Terminal / Port / Bus Station', id: 4 },
                { name: 'Office', id: 5 },
                { name: 'Campus', id: 6 },
                { name: 'Tourism Spot', id: 7 },
                { name: 'Others', id: 8 },
                { name: 'Goverment Public Service', id: 9 },
                { name: 'Modern Market', id: 10 },
                { name: 'Street Food Stall', id: 11 }
            ],
            cdcTeamData: "",
            topResult: "",
            isLoading: true,
            proj_id: "2",
            canCreate: false,
            canEdit: false,
            totalPage: 0,
            pageLimit: 15,
            showingResults: "",
            toggleFilter: false
        }
    },
    async mounted() {

        await this.getTrialDetailByTeam(1);
        this.isLoading = false;
    },
    methods: {
        async getTrialDetailByTeam(pageNum) {

            try {

                const result = await getTrialDetailByTeam(this.data, pageNum, this.pageLimit);

                this.topResult = result.data.data.top_result;
                this.cdcTeamData = result.data.data.cdc_detail_by_teams;
                this.totalPage = this.cdcTeamData.total / this.pageLimit;

                if(this.totalPage % 1 != 0)
                    this.totalPage = parseInt(this.totalPage) + 1;
                else
                    this.totalPage = parseInt(this.totalPage);

                var startPage = 1;
                
                if(pageNum != 1)
                    startPage = (this.pageLimit * (pageNum - 1)) + 1;

                var endPage = pageNum * this.pageLimit;

                if(endPage >= this.cdcTeamData.total)
                    endPage = this.cdcTeamData.total;

                this.showingResults = "Showing " + startPage + " - " + endPage + " of " + this.cdcTeamData.total + " results";
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async pagination(pageNum) {

            this.isLoading = true;  
            
            if(pageNum != 0)
                this.$refs.paginateTop.selected = this.$refs.paginateBottom.selected = pageNum;
            else 
                pageNum = this.$refs.paginateBottom.selected;

            await this.getTrialDetailByTeam(pageNum);

            this.isLoading = false;
        },
        view(tid, lid, uid) {
            this.$router.push({ name: "cdcByBa" , params: { 'tid': tid, 'lid': lid, 'uid': uid , 'date': this.filter.date, 'tlid': this.filter.tlid }});
        },
        clearFilter() {
 
            this.filter.date = new Date();   
            this.filter.category = [];     
        },
        async setFilter() {

            this.isLoading = true;
            await this.getTrialDetailByTeam(1);
            this.isLoading = false;
        },
        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        }
    }
}
</script>